export default __webpack_public_path__ + "0085819bbded1954c054280cb41790d0.png";